module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Bicocca_IndBlue_White.9f47ec23.png";